import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import React from "react";
import EntertainmentRow from "../rows/entertainment";
import PhotosRow from "../rows/photos";
import TwelveStoriesTwoImages from "../rows/twelve-stories-two-images";
import ElevenStoriesElevenImages from "../rows/eleven-stories-eleven-images";
import SixteenStoriesSixteenImages from "../rows/sixteen-stories-sixteen-images";
import FourStoriesFourImages from "../rows/four-stories-four-images";
import TopStoriesCollection from "../rows/top-news";
import VideosRow from "../rows/videos";
import IframeRow from "../rows/iframe";
import FiveStoriesWithLoadMore from "../rows/five-stories-with-loadmore";

function wrapEager(f) {
  return function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={token => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };
}

export default {
  FourStoriesFourImages: wrapEager(wrapCollectionLayout(FourStoriesFourImages)),
  SixteenStoriesSixteenImages: wrapEager(wrapCollectionLayout(SixteenStoriesSixteenImages)),
  ElevenStoriesElevenImages: wrapEager(wrapCollectionLayout(ElevenStoriesElevenImages)),
  PhotosRow: wrapEager(wrapCollectionLayout(PhotosRow)),
  EntertainmentRow: wrapEager(wrapCollectionLayout(EntertainmentRow)),
  TwelveStoriesTwoImages: wrapEager(wrapCollectionLayout(TwelveStoriesTwoImages)),
  TopStoriesCollection: wrapEager(wrapCollectionLayout(TopStoriesCollection)),
  VideosRow: wrapEager(wrapCollectionLayout(VideosRow)),
  IframeRow: wrapEager(wrapCollectionLayout(IframeRow)),
  FiveStoriesWithLoadMore: wrapEager(wrapCollectionLayout(FiveStoriesWithLoadMore)),
  defaultTemplate: wrapEager(wrapCollectionLayout(TopStoriesCollection))
};
